<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>股权设置</el-breadcrumb-item>
      <el-breadcrumb-item>股权列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini" plain @click="toNewEmpCardPage"
               v-if="authorities.includes('yield.set')">新建股权</el-button>
    <el-date-picker
      v-model="yieldRequest.selectDate"
      type="daterange"
      range-separator="至"
      size="mini"
      start-placeholder="请选择日期"
      end-placeholder="请选择日期"
      @change="selectKpiData"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
    <el-select v-model="selectAreaId" v-if="orgLevel == 1"  clearable value filterable placeholder="请选择区域"
               style="margin-left: 5px;width: 200px" size="mini" @change="getArea">
      <el-option
        v-for="org in areas"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="selectOrgId" v-if="orgLevel < 3" clearable value filterable placeholder="请选择门店"
               style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shops"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-input v-model="yieldRequest.searchText" placeholder="请输入股东姓名" size="mini" style="width: 200px;"> </el-input>
    <el-button size="mini" plain @click="loadUserCardList">搜索一下</el-button>
    <el-table height="550px" :data="userCardList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
<!--      <el-table-column-->
<!--        label="操作"-->
<!--        align="center"-->
<!--        width="100">-->
<!--        <template slot-scope="scope">-->
<!--          <div style="display: flex;justify-content: space-evenly">-->
<!--            <el-link type="primary" icon="el-icon-edit"-->
<!--                     @click="toEditPage(scope.row)"></el-link>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
        prop="yieldDate"
        label="设置时间"
        align="center">
      </el-table-column>
      <el-table-column
        prop="shopName"
        label="机构"
        align="center">
      </el-table-column>
      <el-table-column
        prop="userName"
        label="股东姓名"
        align="center">
      </el-table-column>
      <el-table-column
        prop="rate"
        label="股份比例"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createName"
        label="添加人"
        align="center">
      </el-table-column>
      <el-table-column
        prop="modifyTime"
        label="修改时间"
        align="center">
      </el-table-column>
      <el-table-column
        prop="modifyName"
        label="修改人"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      orgLevel:'',
      authorities:'',
      userId:'',
      shops:[],
      areas:[],
      userCardList:[],
      yieldRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
        shopId:'',
        searchText:''
      },
      userName:'',
      selectOrgId:'',
      selectAreaId:'',
    }
  },
  methods:{
    toNewEmpCardPage(){
      this.$router.push('/my/yield/set');
    },
    selectKpiData(){
      if (this.yieldRequest.selectDate === null){
        this.yieldRequest.startDate = '';
        this.yieldRequest.endDate = '';
      } else {
        this.yieldRequest.startDate = this.yieldRequest.selectDate[0];
        this.yieldRequest.endDate = this.yieldRequest.selectDate[1];
      }
    },
    async loadShopList(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shops = res.data;
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.areas = res.data;
      }
    },
    async loadUserCardList(){
      const {data:res} = await this.$http.post(`/load/user/yield/list`, this.yieldRequest);
      if (res.code === 200){
        this.userCardList = res.data;
      }
    },
    getShop(data){
      this.yieldRequest.shopId = data;
    },
    async getArea(data){
      if (data !== ''){
        this.yieldRequest.areaId = data;
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
        this.shops = res.data;
      } else {
        this.yieldRequest.areaId = 0;
      }
    },
    async loadUserYield(userId){
      const {data:res} = await this.$http.get(`/user/yield/${userId}`)
      this.userCardList = res.data;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.yieldRequest.areaId = this.orgId;
      this.loadShopList();
    }
    if (this.orgLevel == 3){
      this.loadUserYield(this.userId);
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/MyYieList.vue